import React, { useEffect, useState } from "react";

function GlassMenuChevron() {
    return (
        <svg aria-hidden className="profile-glass-menu__chevron" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.5 6.75L9 11.25L13.5 6.75" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}

export default function WizardStepTabs({
    stepTitles,
    currentStep,
    maxReachedStep,
    onOpenStep,
    ariaLabel,
}) {
    const [menuOpen, setMenuOpen] = useState(false);
    const canOpenStep = (index) => index <= maxReachedStep;
    const activeTitle = stepTitles[currentStep] || "Шаг";

    useEffect(() => {
        setMenuOpen(false);
    }, [currentStep]);

    const handleOpenStep = (index) => {
        if (canOpenStep(index)) {
            onOpenStep(index);
            setMenuOpen(false);
        }
    };

    return (
        <>
            <nav
                className={`profile-glass-menu new-spot-steps-menu${menuOpen ? " is-open" : ""}`}
                aria-label={ariaLabel}
            >
                <button
                    type="button"
                    className="profile-glass-menu__summary"
                    onClick={() => setMenuOpen((prev) => !prev)}
                    aria-expanded={menuOpen}
                >
                    <span>{activeTitle}</span>
                    <GlassMenuChevron />
                </button>
                <div className="profile-glass-menu__body">
                    {stepTitles.map((title, index) => {
                        const isActive = index === currentStep;
                        const isAvailable = canOpenStep(index);
                        return (
                            <button
                                key={title}
                                type="button"
                                disabled={!isAvailable}
                                className={`profile-glass-menu__link profile-glass-menu__button${isActive ? " is-active" : ""}`}
                                onClick={() => handleOpenStep(index)}
                            >
                                {title}
                            </button>
                        );
                    })}
                </div>
            </nav>
            <div className="new-spot-steps new-spot-steps--desktop" aria-label={ariaLabel}>
                {stepTitles.map((title, index) => {
                    const isActive = index === currentStep;
                    const isAvailable = canOpenStep(index);
                    return (
                        <button
                            key={title}
                            type="button"
                            className={`new-spot-step-btn${isActive ? " is-active" : ""}${isAvailable && !isActive ? " is-available" : ""}${!isAvailable ? " is-disabled" : ""}`}
                            onClick={() => handleOpenStep(index)}
                            disabled={!isAvailable}
                        >
                            <span>{title}</span>
                        </button>
                    );
                })}
            </div>
        </>
    );
}
